export default __webpack_public_path__ + "static/media/softwarePreview.aaa54219.jpeg";